import React, { useEffect, useState } from 'react';
import { Button, ButtonsGroup } from 'components/button';
import { isMzhUserAgent } from 'utils/browser';
import messages from 'messages';
import { generatePath, useHistory } from 'react-router-dom';
import { ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EXERCISES_EXERCISE } from 'routes/RouteList';
import Icon from 'components/icon/Icon';
import { useStore } from 'stores/Store';
import { useIntl } from 'react-intl';

const ExerciseNavigatorButtons = ({ entityId, programId, exerciseId }) => {
  const intl = useIntl();
  const { push } = useHistory();
  const program = useStore(state => state.program);
  const [exerciseIndex, setExerciseIndex] = useState(null);

  useEffect(() => {
    if (program?.exercises) {
      const index = program.exercises.findIndex(e => e.id === exerciseId);
      setExerciseIndex(index);
    }
  }, [exerciseId, program]);

  if (!program || exerciseIndex === null || !program?.exercises) return null;

  return (
    <ButtonsGroup extraClassNames="c-button__group_hylyght-app">
      <Button
        data-label={isMzhUserAgent && intl.formatMessage(messages.previous)}
        circularLarge
        primaryDark
        disabled={exerciseIndex === 0}
        onClick={() => {
          const prevExercise = program.exercises[exerciseIndex - 1];
          push(
            generatePath(
              ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EXERCISES_EXERCISE,
              {
                entityId,
                programId,
                exerciseId: prevExercise.id
              }
            )
          );
        }}
      >
        <Icon id="play" fillColor="color-neutral-x-light" hugeIcon mirrored />
      </Button>
      <Button
        data-label={isMzhUserAgent && intl.formatMessage(messages.next)}
        circularLarge
        primaryDark
        disabled={exerciseIndex === program.exercises.length - 1}
        onClick={() => {
          const nextExercise = program.exercises[exerciseIndex + 1];
          push(
            generatePath(
              ROUTE_EXERCISES_PROGRAMS_ENTITY_PROGRAM_EXERCISES_EXERCISE,
              {
                entityId,
                programId,
                exerciseId: nextExercise.id
              }
            )
          );
        }}
      >
        <Icon id="play" fillColor="color-neutral-x-light" hugeIcon />
      </Button>
      {/* TODO:
            // 1. hoeveel keer is deze oefening gedaan: Teller. Eerste keer tonen we geen badge.
            // 2. `Done` in translations.
            */}
      {/*
          <Button primary>
            <FormattedMessage {...messages.markAsDone} />
          </Button>*/}
    </ButtonsGroup>
  );
};

export default ExerciseNavigatorButtons;
